// extracted by mini-css-extract-plugin
module.exports = {"title":"_2ebddC","countdown":"_2rvEhp","countdownText":"_29Lcnn","digits":"_23l3D-","text":"_3Qo-o9"};